export * from './lowcode/cn-dialog-alc/view';
export * from './lowcode/cn-filter-alc/view';
export * from './lowcode/cn-form-alc/view';
export * from './lowcode/cn-form-dialog-alc/view';
export * from './lowcode/cn-message-alc/view';
export * from './lowcode/cn-page-alc/view';
export * from './lowcode/cn-tab-alc/view';
export * from './lowcode/cn-table-alc/view';
export * from './lowcode/page/view';
export * from './lowcode/cn-step-alc/view';
export * from './lowcode/cn-card-alc/view';
export * from './lowcode/cn-card-sub-card-alc/view';
export * from './lowcode/cn-left-tree-alc/view';
export * from './lowcode/cn-entry-points-alc/view';
// export * from './lowcode/cn-format-alc/view';
// export * from './lowcode/cn-statistic-card-pro-alc/view';
try {
    window.CN_UI_LOWCODE_VERSION = CN_UI_LOWCODE_VERSION;
    console.log(`cn-ui-lowcode 版本号为：${window.CN_UI_LOWCODE_VERSION}`);
}
catch { }
